import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { XOPublicQuietLoading } from "./XOPublicQuietLoading";
import { XOPublicShellWithSuspense } from "./XOPublicShell";
import { SHARED_CONTINUITY_ROOM_DEFAULT_SLUG } from "../lib/shared_continuity_room_hosts";
import { sanitizeSharedContinuityRoomSlug } from "../lib/sharedContinuityRoomUrl";

const XOSharedContinuityRoom = lazy(() => import("../pages/XOSharedContinuityRoom"));

/**
 * `/` → canonical `/<defaultSlug>` (honors `?room=` when present).
 * Used only on `room.xo-vault.com` / `rooms.xo-vault.com` (see `main.tsx`).
 */
export function SharedContinuityRoomHostRootRedirect(): React.ReactElement {
  const { search } = useLocation();
  const q = new URLSearchParams(search).get("room");
  const slug = sanitizeSharedContinuityRoomSlug(q) || SHARED_CONTINUITY_ROOM_DEFAULT_SLUG;
  return <Navigate to={`/${slug}`} replace />;
}

export function SharedContinuityRoomHostApp(): React.ReactElement {
  return (
    <Routes>
      <Route path="/" element={<SharedContinuityRoomHostRootRedirect />} />
      <Route
        path="/:roomSlug"
        element={
          <XOPublicShellWithSuspense loadingLabel="Loading shared continuity room…" fullBleed>
            <Suspense
              fallback={
                <div
                  style={{
                    flex: 1,
                    minHeight: "55vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#1E1B16",
                  }}
                >
                  <XOPublicQuietLoading label="Loading shared continuity room…" />
                </div>
              }
            >
              <XOSharedContinuityRoom />
            </Suspense>
          </XOPublicShellWithSuspense>
        }
      />
      <Route path="*" element={<Navigate to={`/${SHARED_CONTINUITY_ROOM_DEFAULT_SLUG}`} replace />} />
    </Routes>
  );
}
